import { createSelector } from 'reselect';
import { RefundState } from '../../types';
import { getSelectedPassengers } from '../passengers/selectors';
import { ExareInputFile } from '@websky/graphql';
import { getSelectedReason } from '../reason/selectors';
import { getReasonsInfo } from '../refundInfo/selectors';

const getState = (state: RefundState) => state.documents;

export const getDocuments = createSelector(getState, state => state);

export const getIsAllDocumentsProvided = createSelector(
	getSelectedPassengers,
	getState,
	(selectedPassengers, documents) =>
		selectedPassengers.every(selectedPassenger => documents[selectedPassenger.id]?.some(Boolean))
);

export const getRefundFiles = createSelector(
	getState,
	getSelectedPassengers,
	getSelectedReason,
	getReasonsInfo,
	(documentsState, selectedPassengers, selectedReason, reasons): ExareInputFile[] => {
		return Array.prototype.concat.apply(
			[],
			selectedPassengers.map((passenger): ExareInputFile[] => {
				return documentsState[passenger.id]?.filter(Boolean).map(document => ({
					content: document.content,
					originalFileName: document.name,
					type: reasons?.find(reason => reason.reason === selectedReason.title)?.docs[0],
					passengerId: passenger.id
				}));
			})
		);
	}
);
